<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import AppLoadingSkeleton from '@/core/components/app-loading-skeleton.vue';

const router = useRouter();
const isNavigating = ref(true);

router.beforeEach(() => { isNavigating.value = true; });
router.afterEach(() => { isNavigating.value = false; });
</script>

<template>
  <app-loading-skeleton v-if="isNavigating" />
  <router-view v-show="!isNavigating"></router-view>
</template>


<style>
@import '../node_modules/@syncfusion/ej2-base/styles/tailwind.css';
@import '../node_modules/@syncfusion/ej2-buttons/styles/tailwind.css';
@import '../node_modules/@syncfusion/ej2-inputs/styles/tailwind.css';
@import '../node_modules/@syncfusion/ej2-popups/styles/tailwind.css';
@import '../node_modules/@syncfusion/ej2-lists/styles/tailwind.css';
@import '../node_modules/@syncfusion/ej2-navigations/styles/tailwind.css';
@import '../node_modules/@syncfusion/ej2-splitbuttons/styles/tailwind.css';
@import '../node_modules/@syncfusion/ej2-dropdowns/styles/tailwind.css';
@import '../node_modules/@syncfusion/ej2-vue-documenteditor/styles/tailwind.css';
@import "../node_modules/@syncfusion/ej2-vue-spreadsheet/styles/tailwind.css";
@import '../node_modules/@syncfusion/ej2-pdfviewer/styles/tailwind.css';
</style>

